import styled from "styled-components";

export const Card = styled.div`
	align-self: flex-start;
	min-width: 240px;
	padding: 14px 26px;
	border-radius: 6px;
	background: ${({ theme }) => theme.white};
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
	text-align: center;
`;

export const Label = styled.div`
	margin-bottom: 6px;
	font-size: 13px;
	color: ${({ theme }) => theme.neutral.n500};
`;

export const Value = styled.div<{ $hasTotal: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 30px;
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme, $hasTotal }) => ($hasTotal ? theme.neutral.n900 : theme.neutral.n400)};
`;
